import { NoteInterface as ApiNote } from '@vendasta/billing';
import { Note } from '../invoice/invoice';

export function convertAPINote(note: ApiNote): Note {
  return note ? { message: note.message ?? '' } : <Note>{ message: '' };
}

export const isNote = (n: Note | undefined): n is Note => {
  return n ? !!n.message : false;
};
